import { createFileRoute } from "@tanstack/react-router";
import { ErrorAlert, WizardPasoSkeleton } from "@/components/ui";
import { AutorizacionPasoPage } from "@/features/autorizacion/components/AutorizacionPasoPage";
import { solicitudQueryOptions } from "@/features/solicitudes/hooks/use-solicitud";

export const Route = createFileRoute("/_authed-tw/solicitudes/$id/autorizacion")({
  loader: ({ context: { queryClient }, params: { id } }) =>
    queryClient.ensureQueryData(solicitudQueryOptions(id)),
  component: AutorizacionPasoPage,
  pendingComponent: WizardPasoSkeleton,
  errorComponent: ({ error }) => <ErrorAlert error={error} />,
});
